<div class="menu-container">
	<div class="icon-container">
		<i
			class="icon-callback"
			[tooltip]="'Arrange Callback'"
			[placement]="'bottom'"
			[attr.data-element-click]="'callback_icon__' + location + '__[Arrange Callback]'"
			(click)="onShowCallback()"
		></i>
	</div>
	<div class="icon-container">
		<i
			class="icon-save"
			(click)="onShowCustomerDetails('save')"
			[tooltip]="'Save for later'"
			[placement]="'bottom'"
			[attr.data-element-click]="'save_icon__' + location + '__[Save for later]'"
		></i>
	</div>
	<div class="icon-container">
		<i
			class="icon-user"
			[tooltip]="'Your Details'"
			[placement]="'bottom'"
			[attr.data-element-click]="'your_details_icon__' + location + '__[Your Details]'"
			(click)="onTogglePopover()"
		></i>
		<ui-popover
			class="user-popover"
			*ngIf="popoverExists"
			[show]="popoverShow"
			[placement]="'bottom right'"
			[minWidth]="190"
			[showArrow]="true"
		>
			<ul class="link-list">
				<li>
					<a
						[attr.data-element-click]="'your_details_link__' + location + '__[Your Details]'"
						(click)="onShowCustomerDetails('details')"
					>
						Your Details
					</a>
				</li>
				<li>
					<a
						[attr.data-element-click]="'forget_me_link__' + location + '__[Forget me on this device]'"
						(click)="onForget()"
					>
						Forget me on this device
					</a>
				</li>
			</ul>
		</ui-popover>
	</div>
</div>
